import React from "react";
import { Container } from "react-bootstrap";
import "../Navbar/nav.css";

export default function Footer() {
  return (
    <Container fluid className="footerStyle">
      Copyright @2020-2021 Sabka Bazar Grocery Supplies PVT. LTD
    </Container>
  );
}
